/* Carnis – felles småskript (okt. 2026, v2). Lastes på alle sider fra sections/carnis-header-stil.liquid.
   1) «Legg i handlekurv»-knapper utenfor produktskjemaet ([data-carnis-add], f.eks. «Passer godt sammen med»):
      legger varen i kurven som engangskjøp og åpner handlekurven (temaets cart-drawer).
   2) Bevis-stripen (.cpdp-proof__list): på mobil ruller punktene sakte og sømløst, så ingenting blir kuttet.
   Ingen avhengigheter. */
(function () {
  'use strict';
  if (window.__carnisV2) return;
  window.__carnisV2 = true;

  /* ---------------- 1) Legg i handlekurv ---------------- */
  function addToCart(btn) {
    var id = Number(btn.getAttribute('data-variant'));
    if (!id || btn.disabled) return;
    var qty = Number(btn.getAttribute('data-qty')) || 1;
    var holder = btn.closest('[data-carnis-add-scope]') || btn.parentNode.parentNode;
    var err = holder ? holder.querySelector('[data-carnis-add-err]') : null;
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
    }
    var routes = window.routes || {};
    btn.disabled = true;
    btn.classList.add('is-busy');
    if (err) err.hidden = true;
    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart'); return j; });
    }).then(function (j) {
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'carnis-add', productVariantId: id, cartData: j });
        }
      } catch (e) {}
      if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
        drawer.renderContents(j);
      } else {
        window.location.href = routes.cart_url || '/cart';
      }
    }).catch(function () {
      if (err) err.hidden = false;
    }).then(function () {
      btn.disabled = false;
      btn.classList.remove('is-busy');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-carnis-add]') : null;
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ---------------- 2) Bevis-stripen på mobil ---------------- */
  var mq = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setupProof(list) {
    if (list.dataset.carnisTicker) return;
    var items = Array.prototype.slice.call(list.children);
    if (items.length < 2) return;
    list.dataset.carnisTicker = '1';
    var track = document.createElement('div');
    track.className = 'cpdp-proof__ticker';
    var a = document.createElement('div');
    a.className = 'cpdp-proof__run';
    items.forEach(function (li) {
      var span = document.createElement('span');
      span.className = 'cpdp-proof__item';
      // Nov. 2026: kopier innholdet, ikke bare teksten, så stjernene (svg fra carnis-stjerner) også vises i stripen
      Array.prototype.forEach.call(li.childNodes, function (n) { span.appendChild(n.cloneNode(true)); });
      a.appendChild(span);
    });
    var b = a.cloneNode(true);
    b.setAttribute('aria-hidden', 'true');
    track.appendChild(a);
    track.appendChild(b);
    list.parentNode.insertBefore(track, list.nextSibling);
    list.classList.add('cpdp-proof__list--static');
    // Farten følger lengden, så punktene alltid kan leses
    var len = a.textContent.length;
    track.style.setProperty('--carnis-ticker-dur', Math.max(18, Math.round(len * 0.32)) + 's');
  }
  function bootProof() {
    if (reduce) return;
    Array.prototype.forEach.call(document.querySelectorAll('.cpdp-proof__list'), setupProof);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootProof); else bootProof();
  document.addEventListener('shopify:section:load', bootProof);
  if (mq && mq.addEventListener) mq.addEventListener('change', bootProof);
})();
